export const NO_QUEUE_MINS = 15;
